import { DOCUMENT } from '@angular/common';
import { Injectable, inject, signal } from '@angular/core';

import { BUILD_VERSION } from '../../../environments/build-version';
import { APP_ENV } from '../tokens/app-environment.token';

const CHECK_INTERVAL_MS = 1 * 60 * 1000;

@Injectable({ providedIn: 'root' })
export class AppVersionService {
  private readonly document = inject(DOCUMENT);
  private readonly appEnv = inject(APP_ENV);

  private monitoringStarted = false;

  readonly updateAvailable = signal(false);

  startMonitoring(): void {
    if (!this.appEnv.enableAppVersionCheck) {
      return;
    }

    const window = this.document.defaultView;
    if (this.monitoringStarted || !window) {
      return;
    }
    this.monitoringStarted = true;

    void this.checkForUpdate();
    window.setInterval(() => void this.checkForUpdate(), CHECK_INTERVAL_MS);
    window.addEventListener('visibilitychange', () => {
      if (this.document.visibilityState === 'visible') {
        void this.checkForUpdate();
      }
    });
  }

  reloadApp(): void {
    this.document.defaultView?.location.reload();
  }

  async checkForUpdate(): Promise<void> {
    const window = this.document.defaultView;
    if (!window) {
      return;
    }

    try {
      const url = new URL('version.json', this.document.baseURI);
      url.searchParams.set('t', String(Date.now()));
      const response = await window.fetch(url, { cache: 'no-store' });
      if (!response.ok) {
        return;
      }
      const manifest = (await response.json()) as { version?: string };
      if (manifest.version && manifest.version !== BUILD_VERSION) {
        this.updateAvailable.set(true);
      }
    } catch {
      /* offline or missing manifest */
    }
  }
}
